import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef } from 'react';
import { useAnalytics } from '../../../../../../common/analytics';
import { useProductContext } from '../../../..';
import { useDialogExpansionContext } from '../../../../../dialog-expansion-context';
import { preQueryAnalyticsGenerator } from './pre-query-analytics-generator';
import { postQueryAnalyticsGenerator } from './post-query-analytics-generator';
import { useGetCurrentProductFilters } from '../../../../../filters/filters-helper-functions';
import { transformFiltersForAnalytics } from './filters-context-transformer';
import { errorAnalyticsGenerator } from './error-analytics-generator';
export var useProductStateAnalytics = function useProductStateAnalytics(productState, preQueryItems, postQueryItems) {
  useCommonConditions(productState, preQueryAnalyticsGenerator, preQueryItems);
  useCommonConditions(productState, postQueryAnalyticsGenerator, postQueryItems);
  useCommonConditions(productState, errorAnalyticsGenerator, {
    sections: [],
    size: 0
  });
};
export var useCommonContext = function useCommonContext() {
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var _useProductContext = useProductContext(),
    products = _useProductContext.products,
    getActiveProduct = _useProductContext.getActiveProduct;
  var filters = useGetCurrentProductFilters();
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  var activeProduct = getActiveProduct();
  var isMultiProduct = products.length > 0;
  return [fireAnalyticsEvent, activeProduct, isExpanded, isMultiProduct, transformFiltersForAnalytics(filters)];
};
// for testing only
export var useCommonConditions = function useCommonConditions(productState, analyticsGenerator, searchItems) {
  var previousStateOfStateMachine = useRef();
  var _useCommonContext = useCommonContext(),
    _useCommonContext2 = _slicedToArray(_useCommonContext, 5),
    fireAnalyticsEvent = _useCommonContext2[0],
    activeProduct = _useCommonContext2[1],
    isExpanded = _useCommonContext2[2],
    isMultiProduct = _useCommonContext2[3],
    filters = _useCommonContext2[4];
  useEffect(function () {
    if (isExpanded && activeProduct && activeProduct.id !== '' && activeProduct.isDisplayed && previousStateOfStateMachine.current) {
      var _commonAttributes = {
        activeProduct: activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id,
        isMultiProduct: isMultiProduct,
        filters: filters
      };
      var payload = analyticsGenerator(productState, _commonAttributes, previousStateOfStateMachine.current, searchItems);
      if (payload && Object.keys(payload).length > 0) {
        fireAnalyticsEvent(payload);
      }
    }
    previousStateOfStateMachine.current = productState;
  }, [productState, isExpanded, fireAnalyticsEvent, isMultiProduct, activeProduct, searchItems, analyticsGenerator, filters]);
};